<template>
  <div class="right-panel-secondary-content-graph-wrap">
    <div class="small-graph">
      <div class="small-graph-header">
        <div class="small-graph-name">{{ label }}</div>
        <div class="small-graph-count" v-if="percent !== undefined">
          {{ formattedPercent }}%
        </div>
      </div>
      <div class="small-graph-bar-wrap" v-if="percent !== undefined && chart">
        <div class="small-graph-bar">
          <div
            class="small-graph-bar-fill"
            :style="`width: ${formattedPercent}%`"
            style="width: 30%;"
          ></div>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "RoeSurveyBar",
  props: {
    label: {
      type: String,
      required: true
    },
    percent: {
      type: Number,
      required: false,
      default: 0
    },
    percentPrecision: {
      type: Number,
      required: false,
      default: 0
    },
    chart: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    formattedPercent() {
      return (this.percent * 100).toFixed(this.percentPrecision);
    }
  }
};
</script>
